module.exports = __webpack_public_path__ + "img/Group 833.97f7acf6.png";